export const useExerciseProgressionInfo = (
  allProgressions: Ref<ProgressionSchema[]>,
  quizId: String
) => {
  const progression = computed<ProgressionSchema>(() => {
    if (!allProgressions.value) return null;
    return allProgressions.value.find(
      (progression) => quizId === progression.contentId
    );
  });

  const exerciseDetailsProgression = computed(() => {
    if (progression.value) {
      return progression.value.data as ExerciseDetailsProgression;
    } else {
      return null;
    }
  });

  const isCompleted = computed(() => {
    if (!exerciseDetailsProgression.value) return false;
    return exerciseDetailsProgression.value.status === 'done';
  });

  const score = computed(() => {
    if (!isCompleted.value) return 0;
    const { points, maxPoints } = exerciseDetailsProgression.value;

    return points / maxPoints;
  });

  const scoreOutOf20 = computed(() => {
    return getScoreOn20(score.value);
  });

  return {
    isCompleted,
    score,
    scoreOutOf20,
    progression,
  };
};
